import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import React from 'react';
import classnames from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import BiDiv from '@wix/da-bi/pkg/Components/BiDiv';
import ConditionalWrapper from '../../../ConditionalWrapper';
import ErrorBoundary from '../../../ErrorBoundary';
import { getFolderCardSizeBasedOnWidth } from '../../helpers';
import folderCardStyles from '../../FolderCard.scss';
export const FolderCardLayout = ({ className , contentClickBiData , dataHook , content , ribbon , footer , wrapCondition , wrap , isSelected , onClick , width , withShadow  })=>{
    const size = getFolderCardSizeBasedOnWidth(width);
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "FolderCardLayout"
    }, /*#__PURE__*/ React.createElement(Section, {
        className: classnames(folderCardStyles['root'], withShadow && folderCardStyles['with-shadow'], onClick && folderCardStyles['clickable'], folderCardStyles[size], className),
        style: {
            width
        }
    }, /*#__PURE__*/ React.createElement(ConditionalWrapper, {
        condition: wrapCondition,
        wrap: wrap
    }, /*#__PURE__*/ React.createElement(BiDiv, {
        className: classnames(folderCardStyles['content'], isSelected && folderCardStyles['selected']),
        onClick: onClick,
        biData: BiData(_object_spread({
            evid: 100,
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue,
            rank: BiContextProvidedValue,
            sectionname: BiContextProvidedValue,
            widgetname: BiContextProvidedValue
        }, contentClickBiData)),
        "data-hook": dataHook
    }, /*#__PURE__*/ React.createElement("div", {
        className: folderCardStyles['preview-container']
    }, content), ribbon && /*#__PURE__*/ React.createElement("div", {
        className: folderCardStyles['ribbon-wrapper']
    }, ribbon), /*#__PURE__*/ React.createElement("div", {
        className: folderCardStyles['footer']
    }, footer)))));
};
export default FolderCardLayout;
